import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Insignias } from 'uikit/insignias';
import { Skeleton } from 'uikit/loaders';
import { Typo } from 'uikit/content';

import ProfileSkillsList from './profileSkillsList';

import styles from '../styles/profileSkills.module.scss';

const ProfileSkills = ({ data = {}, isLoading = true }) => {
  const [isShowingAllSkills, setIsShowingAllSkills] = useState(false);

  const { skills = [], total_reputation_points: reputationPoints = 0 } = data;

  const initialSkillsCount = 8;
  let skillsList = skills;

  const isShowingExpandButton = skillsList && skillsList.length > initialSkillsCount;

  if (skillsList && !isShowingAllSkills) {
    skillsList = skillsList.slice(0, initialSkillsCount);
  }

  const onShowAllSkillsClick = () => {
    setIsShowingAllSkills(!isShowingAllSkills);
  };

  const insignias = [
    {
      ariaLabel: i18n.t('count-reputation', { count: reputationPoints }),
      icon: 'reputation',
      text: reputationPoints ? reputationPoints.toString() : '0',
      tooltip: i18n.t('reputation'),
    },
  ];

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <Typo element="h2" variant="d02">
          {i18n.t('skills')}
        </Typo>
        {isLoading ? (
          <Skeleton className={styles.insignias} width={50} height={26} />
        ) : (
          <Insignias className={styles.insignias} insigniasIconSize={18} insignias={insignias} />
        )}
      </header>
      <ProfileSkillsList
        skills={skills}
        initialSkillsCount={initialSkillsCount}
        isLoading={isLoading}
        isShowingAllSkills={isShowingAllSkills}
        isShowingExpandButton={isShowingExpandButton}
        onShowAllSkillsClick={onShowAllSkillsClick}
      />
    </section>
  );
};

ProfileSkills.propTypes = {
  data: PropTypes.shape({
    skills: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        reputation_points: PropTypes.number.isRequired,
        hex_color: PropTypes.string.isRequired,
      }),
    ).isRequired,
    total_reputation_points: PropTypes.number.isRequired,
  }),
  isLoading: PropTypes.bool,
};

export default React.memo(ProfileSkills);
